var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "fc-text-center fc-mar-t-biger" }, [
      _c("div", { staticClass: "fc-bg-fff fc-pad-b-sm" }, [
        _c("img", {
          staticClass: "login_logo",
          attrs: { src: require("../../assets/img/logo.png") }
        }),
        _vm._v(" "),
        _c("p", { staticClass: "fc-text-bigabit fc-mar-t fc-pad-lr-biger" }, [
          _vm._v(_vm._s(_vm.$t("m.scanLogin")))
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "fc-relative" }, [
          _c("div", { staticClass: "qrcode", attrs: { id: "qrcode" } }, [
            _vm.qrcodeUrl
              ? _c("img", { attrs: { src: _vm.qrcodeUrl, alt: "" } })
              : _vm._e(),
            _vm._v(" "),
            _vm.qrCodeTimeOut
              ? _c(
                  "div",
                  {
                    staticClass: "fail_mask",
                    on: {
                      click: function($event) {
                        return _vm.getQrcodeInfo()
                      }
                    }
                  },
                  [
                    _c("img", {
                      staticClass: "qrcode_ref_icon",
                      attrs: { src: require("../../assets/img/refresh.png") }
                    })
                  ]
                )
              : _vm._e()
          ])
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "login_tip" }, [
          _vm._v(_vm._s(_vm.$t("m.scanTip")))
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "login_tip" }, [
          _vm._v("("),
          _c("span", { attrs: { id: "scanVersion" } }, [
            _vm._v(_vm._s(_vm.moreLang.scanVersion))
          ]),
          _vm._v(")")
        ])
      ])
    ]),
    _vm._v(" "),
    _c("p", { staticClass: "fc-notice loginLesson" }, [
      _c("a", { on: { click: _vm.gotoask } }, [
        _vm._v(_vm._s(_vm.$t("m.scan_login_lesson")))
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-73704780", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73704780","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href","audio":"src"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login/LoginScan.vue
// module id = null
// module chunks = 